import { render } from "./IosManual.vue?vue&type=template&id=119fdf59&scoped=true"
import script from "./IosManual.vue?vue&type=script&lang=js"
export * from "./IosManual.vue?vue&type=script&lang=js"

import "./IosManual.vue?vue&type=style&index=0&id=119fdf59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119fdf59"]])

export default __exports__